/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './patient-procedure-medicine.reducer';

export const PatientProcedureMedicineDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const patientProcedureMedicineEntity = useAppSelector(state => state.patientProcedureMedicine.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="patientProcedureMedicineDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.patientProcedureMedicine.detail.title">PatientProcedureMedicine</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.patientProcedureMedicine.id">Id</Translate>
            </span>
          </dt>
          <dd>{patientProcedureMedicineEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.patientProcedureMedicine.active">Active</Translate>
            </span>
          </dt>
          <dd>{patientProcedureMedicineEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.patientProcedureMedicine.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{patientProcedureMedicineEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.patientProcedureMedicine.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{patientProcedureMedicineEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.patientProcedureMedicine.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{patientProcedureMedicineEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.patientProcedureMedicine.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{patientProcedureMedicineEntity.timestampentry}</dd>
          <dt>
            <span id="quantity">
              <Translate contentKey="tinyMedicRestApp.patientProcedureMedicine.quantity">Quantity</Translate>
            </span>
          </dt>
          <dd>{patientProcedureMedicineEntity.quantity}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientProcedureMedicine.medicine">Medicine</Translate>
          </dt>
          <dd>{patientProcedureMedicineEntity.medicine ? patientProcedureMedicineEntity.medicine.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientProcedureMedicine.order">Order</Translate>
          </dt>
          <dd>{patientProcedureMedicineEntity.order ? patientProcedureMedicineEntity.order.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/patient-procedure-medicine" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/patient-procedure-medicine/${patientProcedureMedicineEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PatientProcedureMedicineDetail;
